export default __webpack_public_path__ + "static/media/toggle.3398e227.svg";